import { useEffect, useState } from "react";

import { _ActaComite } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import { Modal } from "../../../../theme/Component/Modal";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { BasicButton } from "../../../../theme/Component/BasicButton";


export interface ActaComite {
    IDActaComite: number;
    ComiteNumber: string;
}

interface BaseProps {
    label?: string;
    renderActa?: string;
    IDSelect?: number;
}


interface SingleSelectProps extends BaseProps {
    onChange: (value: ActaComite) => void;
}

interface formProps {
    Year: number
}

export const EditorActaComite = ({ label, onChange, renderActa, IDSelect }: SingleSelectProps) => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_ActaComite);
    const [form, setForm] = useState<Partial<formProps>>({})

    const [valor, setValor] = useState<string>("");
    const paginador = usePaginator();

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        setValor(renderActa)
    }, [renderActa])

    useEffect(() => {
        getLista();
    }, [paginador.pages])

    const returnData = () => {
        if (!bean.IDActaComite) {
            toast.error("Acta de Comite no valida");
        } else {
            setValor(`${bean.IDActaComite} - ${bean.ComiteNumber}`);

            (onChange as (value: ActaComite) => void)(bean);

            setModal({ ...modal, view: false });
        }
    };

    const getLista = () => {
        const Props: any = {}

        // if (form.Year) Props.Since = form.Year;

        instance.getActaComiteResumen(paginador.page, 15, Props, null, null).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                setLista(resp.List)
            }
        ).catch(
            errr => { toast.error(errr) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDActaComite', visible: false, mask: MASK_NUMBER },
        { title: 'No. Comite', property: 'ComiteNumber', visible: true },
        { title: 'Fecha de Aprobación', property: 'ApprovedDate', visible: true, mask: MASK_DATE },
        { title: 'Total Solicitado', property: 'totalCreditos', visible: true, mask: MASK_MONEY },
        { title: 'Total Deducciones', property: 'totalDeduccionesCapital', visible: true, mask: MASK_MONEY },
        { title: 'Total Interes', property: 'totalDeduccionesIntereses', visible: true, mask: MASK_MONEY },
        { title: 'Total Desembolso', property: 'totalDesembolso', visible: true, mask: MASK_MONEY },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'No. Proceso', property: 'IDProcess', visible: true, mask: MASK_NUMBER },
        { title: 'Fecha Proceso', property: 'ProcessDate', visible: true },
        { title: 'Estado Proceso', property: 'ProcessStateName', visible: true },

    ]

    const [listaResult, setListaResult] = useState<any>([]);

    const clearSelection = () => {
        setValor("");
        (onChange as (value: ActaComite | null) => void)(null as any);
        setBean({});
    };


    return (
        <>
            <label>{label ?? "Acta de Comite"}</label>
            <div
                className="form-control d-flex justify-content-between align-items-center"
                style={{ minHeight: '35px', cursor: "pointer" }}
                onClick={() => setModal({ ...modal, view: true })}
            >
                {valor ? (
                    <>
                        <span>{valor}</span>
                        <button
                            type="button"
                            className="btn btn-sm btn-link text-danger"
                            style={{ textDecoration: "none" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                clearSelection();
                            }}
                        >
                            ✕
                        </button>
                    </>
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={() => { returnData() }}>
                <div className="row">
                    <div className="col-md-4">
                        <YearSelector value={form.Year} tittle="Vigencia" onChange={(e) => { setForm({ ...form, Year: e ?? null }) }} />
                    </div>
                    <div className="col-md-3">
                        <BasicButton useMargin eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} />
                    </div>
                    <div className="col-md-12">
                        <BasicTable records={paginador} body={lista} head={head} rowSet={setBean} />
                    </div>
                </div>
            </Modal>
        </>
    )
}